import styles from './statement-dropdown.module.scss';
import { Button, Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import { StatementDropdownProps } from 'modules/clients/types/transaction-summary';
import { useState } from 'react';

const StatementDropdown = ({
  title,
  subtitle,
  titleDescription,
  statementDescription,
  shoudShowCollapse,
  buttonTitle,
  children,
  testid,
  isOpen,
  onToggle
}: StatementDropdownProps) => {
  const [isStatementDropdownOpen, setIsSatementDropdownOpen] = useState(true);
  const heading = () => {
    return (
      <div className={styles.panelHeading}>
        <Typography
          data-testid={`${testid}PanelHeading`}
          variant={Typography.VARIANT.B1}
          weight={Typography.WEIGHT.MEDIUM}
        >
          {title}
        </Typography>
        <Typography
          className={styles.headingDateContainer}
          variant={Typography.VARIANT.B2}
          weight={Typography.WEIGHT.MEDIUM}
        >
          {subtitle}
        </Typography>
        {titleDescription && (
          <Typography variant={Typography.VARIANT.B4} weight={Typography.WEIGHT.NORMAL}>
            {titleDescription}
          </Typography>
        )}
      </div>
    );
  };

  const expandOrCollapse = isOpen === undefined ? isStatementDropdownOpen : isOpen;

  const collapse = () => {
    return (
      shoudShowCollapse && (
        <div className={styles.collapseContainer}>
          <Typography className={styles.statementDescription} variant={Typography.VARIANT.B4}>
            {statementDescription}
          </Typography>
          <Button
            className={styles.collapseButton}
            variant={Button.VARIANT.TERTIARY}
            size={Button.SIZE.SMALL}
            onClick={() => {
              onToggle ? onToggle() : setIsSatementDropdownOpen(!isStatementDropdownOpen);
            }}
            endIcon={
              <Icon
                icon={
                  expandOrCollapse
                    ? ICONS_ENUM.HARDWARE_KEYBOARD_ARROW_UP
                    : ICONS_ENUM.HARDWARE_KEYBOARD_ARROW_DOWN
                }
                className={styles.chevronIcon}
              />
            }
          >
            {expandOrCollapse ? `Collapse ${buttonTitle}` : `Expand ${buttonTitle}`}
          </Button>
        </div>
      )
    );
  };

  return (
    <div data-testid={`${testid}PanelContainer`} className={styles.container}>
      <div data-testid={`${testid}Panel`} className={styles.heading}>
        {heading()}
        {collapse()}
      </div>
      <div className={styles.content}>
        {children({ isDropdownCollapsed: isOpen === undefined ? isStatementDropdownOpen : isOpen })}
      </div>
    </div>
  );
};

export default StatementDropdown;
